<style>
  .clearfix:after {
    content: '';
    display: block;
    visibility: hidden;
    clear: both;
  }
  .select-container {
    padding: 15px 2% 3px;
  }
  .select-left {
    float: left;
    display: table;
  }
  .select-left > div {
    vertical-align: top;
  }
  .select-left > div:not(:last-child) {
    margin-right: 5px;
  }
  .select-right {
    float: right;
  }
</style>

<template>
  <div>
    <div class="select-container clearfix" style="margin-top: 2%;margin-left: 2%;float: left;">
    <span style="font-size:30px;font-weight:bold;">DLP安装指南 for windows</span><br><br>
    <p style="text-align: start;">软件下载地址：<a style="color:#1890ff" title="https://itportal.sankuai.com/" href="https://itportal.sankuai.com/" class="ct-link" rel="noopener" target="_blank">https://itportal.sankuai.com/</a></p>
    <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic15.png" width=850px height=280px ><br>
    <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic16.png" width=850px height=330px ><br>

    <p><span style="color: rgb(112, 112, 112)">一、软件安装</span>DLP主要安装过程包含三部分内容：</p>
    <p><span style="color: rgb(112, 112, 112)">一、软件安装</span></p>
    <p>二、绑定用户名</p>
    <p style="text-align: start;"><span style="color: rgb(255, 0, 0)">一、软件安装</span></p>
    已安装赛门铁克杀毒软件的电脑双击下载好的安装包若弹出如下弹框，<span style="font-weight:bold">选择“允许使用此文件”</span><br>
    <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic1.jpg" width=600px height=600px ><br>
    点击“确定”<br>
    <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic2.jpg" width=600px height=600px ><br>
    双击下载后的文件出现解压信息如下图，选择需要解压到的文件夹点击“解压”：<br>
    <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic3.png" width=600px height=400px ><br><br>
    解压终端安装包后文件包括：<br>
   1) 终端安装程序 MT-DLP.exe     用于进行终端完整安装<br>
   2）msec.dat 文件<br>
   <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic4.png" width=300px height=150px ><br><br>
   终端安装步骤如下：<br>
   1、 右键— MT-DLP.exe，<span style="color:red">以管理员身份安装</span>，弹出框图填写mis账号（外包职场用户在本步骤中请填写meituan）<br>
   <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic5.jpg" width=350px height=120px ><br><br>
   进入安装界面<br>
   <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic6.png" width=600px height=450px ><br>
   2、点击“浏览”按钮，选择安装目录。默认安装目录为：C:\Program Files\CirrusGate\dlp3.0<br>
   <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic7.png" width=600px height=400px ><br>
   3、 点击“下一步”按钮，如果此计算机安装过DLP3.0，卸载后会有残余文件，忽略这些文件。<br>
   <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic8.png" width=500px height=350px ><br>
   4、 点击“是”，进入下一安装界面<br>
   <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic9.png" width=500px height=350px ><br>
   5、点击“下一步”，进入“准备开始安装”界面。<br>
   <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic10.png" width=500px height=350px ><br>
   6、 点击“安装”按钮，显示安装进度条。<br>
   <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic11.png" width=500px height=350px ><br>
   7、 安装完成后提示界面， 点击“完成”按钮，完成DLP3.0的Windows终端安装。<br>
   <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic12.png" width=500px height=350px ><br><br>
   <span style="font-size:20px;color:red;">二、绑定账号</span><br>
   <span style="font-size:18px;color:red;">注意 ：部分域内WINDOWS用户会自动绑定，无需以下步骤！！！！！！</span><br>
    安装完成后 会跳出如下界面<br><br>
    <span style="font-size:25px;color:red;">注意 ：<br>
   （1）账号为mis账号，请填写正确的mis账号；<br>
   （2）如使用自己的mis帐号提示用户名不存在，请输入meituan。<br>
    如：用户名：meituan</span><br>
    <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic13.png" width=400px height=300px ><br><br>
    <span style="font-size:25px;color:red;">安装过程中，程序会自动识别您的mis账号，若无法识别，程序会打开一个浏览器，并打开一个如下的注册页面，请务必真实填写您的真实信息！！<br>
    如果未出现弹窗说明被系统识别mis账号，忽略此步骤（<span style="color:blue;">已安装却仍收到SSO消息提醒 ，解决方法详见</span>
    <span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="kmUrl('https://km.sankuai.com/page/19884626')">已安装却仍收到SSO消息提醒</span>
    ）</span><br>
    <img src="../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic14.png" width=500px height=400px ><br>
    <span style="font-size:15px;color:red;">有问题可以直接大象6000或者私聊huawei02。</span>
    <br><br>
    </div>
  </div>
</template>

<script>
  import store from '../vuex/service/store'
  import axios from 'axios'
  import {mapState} from 'vuex';
  import util from '../views/util/commonUtil'

  export default {
    store: store,
    mounted: function () {
      var vm =this;
      if(vm.token == ""){
        var token = this.getCookie("access-token");
        if(token != null){
          vm.$store.commit('UPDATETOKEN',token);
          vm.token = token;
        }
      }
      vm.getUser();
    },
    computed: mapState({
      loginRediret: function (state) {
        return state.loginRediret;
      },
      cookieName: function (state) {
        return state.cookieName;
      },
      getuserAPI: function (state) {
        return state.getuserAPI;
      }
    }),
    filters: {
      idcExplain(val) {
        return util.idcExplain(val)
      },
      timeFormat(val) {
        return util.timeFormat(val)
      },
      switchColor(val) {
        return util.switchColor(val)
      },
      statusExplain(val) {
        return util.statusExplain(val)
      }
    },
    methods: {
      reset() {
        var vm = this;
        vm.name = '';
        vm.rasp = '';
        vm.proc = '';
        vm.ws = '';
        vm.query_arg = 'hostname';
        vm.query_value = '';
      },
      masterStatusColor(status) {
        if (status == 1) {
          return "#A1D6E4"
        }
        if (status == 0) {
          return "#878D99"
        }
        if (status == 4) {
          return "#878D99"
        }
        if (status == 6) {
          return "#F5A9A9"
        }
        if (status == 5) {
          return "#FFC78E"
        }
      },
      kmUrl(URL){
        window.open(URL);
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      getCookie(name){
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg))
          return unescape(arr[2]);
        else
          return null;
      },
      getUser() {
        var vm = this;
        if (vm.user == null || vm.user == "") {
          vm.user = vm.getCookie("username");
          document.cookie="ssoid="+vm.getCookie("access-token");
          axios.get(vm.getuserAPI, {
            withCredentials: true
          }).then((response) => {
            if(response.data.status==401){
               document.cookie = vm.cookieName + vm.$route.fullPath;
               window.location = vm.loginRediret;
            }

          }).catch(function (error) {
            vm.requesterrorinfo(error)
          })
        }
      },
      requesterrorinfo(error){
        var vm =this;
        if (error.response) {
          var code = error.response.status;
          if (code == 401) {
            vm.$message.error("401:您未登录");
            var count = vm.getCookie("access-count")
            window.location = vm.loginRediret;
            if(count==null || count==0){
              document.cookie="access-count=1";
              vm.$message('您未登录,请刷新');
              document.cookie = vm.cookieName + vm.$route.fullPath;
              window.location = vm.loginRediret;
            }else{
              vm.$message('您未登录,请刷新');
            }
          } else {
            if (code == 404) {
              vm.$notify({
                title: '提示',
                message: '404:Not found!',
                type: 'error'
              });
            } else {
              vm.$notify({
                title: '提示',
                message: '501:服务端未响应!',
                type: 'error'
              });
            }
          }
        } else {
          vm.$notify({
            title: '提示',
            message: '502:服务端未响应!',
            type: 'error'

          });
        }
      }
    },
    data() {
      return {
        hostname:'',
        token:''
      }
    }
  }
</script>
<style>
  .select1 {
    width: 100px;
  }
  .select2 {
    width: 130px;
  }
  .select3 {
    width: 160px;
  }
  .input1 {
    width: 350px;
  }
  .input2 {
    width: 210px;
  }
  .demo-table-expand label {
    width: 140px;
    color: #5d94bf;
  }
</style>



// WEBPACK FOOTER //
// dataLeakInstallForWin.vue?692012c4